define('models/Wrapup',[
    'lib/lodash4',
    'moment',
    'util/ObservableModel'
], function (_, moment, ObservableModel) {
    'use strict';

    /**
     * Represents the wrapup data associated with a communication.
     */
    return ObservableModel.extend({
        defaults: {
            startTime: null,
            code: null,
            notes: '',
            tags: [],
            durationSeconds: null,
            endTime: null,
            availableCodes: []
        }
    }, function () {
        var self = this;

        self.unwrap = function () {
            var data = ObservableModel.unwrap(self, [
                'id',
                'startTime',
                'errors',
                'isAnyMessageShown',
                'isValid',
                'unwrap',
                'availableCodes'
            ]);

            data.endTime = moment().toISOString();
            data.tags =  _.map(self.tags(), 'label');

            return data;
        };
    });
});
